import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Button,
  Typography,
  Skeleton,
  Switch,
  Menu,
  Dropdown,
} from "antd";
import { Colors } from "../../../../theme";
import ShareCatalogue from "assets/images/share_catalogue.svg";
import SendApproval from "assets/images/send_approval.svg";
import SendForApprovalModal from "./SendForApprovalModal";
import GenarateCatalogoueModal from "./GenarateCatalogoueModal";
import { IoCloudDoneOutline } from "react-icons/io5";
import { AiTwotoneShop } from "react-icons/ai";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import Tour from "reactour";
import API_KEY from "api";
import * as GA from "constants/analytics";
import { gaEvent } from "analytics/analytics";
import Can from "../../../../casl/Can";
import {PERMISSIONS} from "constants/permissions"
const { Title, Text } = Typography;

const getCSVAndVisibleAttrs = (categories = []) => {
  const attrs = [];
  categories?.forEach((category) => {
    category?.values?.forEach((product) => {
      product?.attributes?.forEach((attr) => {
        const visibleAttr = new Set(product.visible_attributes);
        if (
          attr?.dtype === "csv" &&
          visibleAttr.has(attr?.attribute_id?.toString())
        ) {
          //
          attrs.push(attr);
        }
      });
    });
  });

  const key = "name";

  const uniqueAttrs = [
    ...new Map(attrs.map((item) => [item[key], item.name])).values(),
  ];
  return uniqueAttrs;
};

export default function PageTitle({
  collectionDetails,
  showInternals,
  setShowInternals,
  saving,
  saveAsDraft,
  handleContinue,
  handlePreview,
  history,
  collectionId,
  validator,
  setGenarateCatalogoueModalVisible,
  genarateCatalogoueModalVisible,
  setFieldsModalVisible,
  setShowTour,
  showTour,
  tableData,
  continueButtonLoading,
  setContinueButtonLoading,
}) {
  const uniqueAttrs = getCSVAndVisibleAttrs(tableData);
  const [sendForApprovalModalVisible, setSendForApprovalModalVisible] =
    useState(false);

  const [showCloudIcon, setShowCloudIcon] = useState(true);

  const showApprovalModal = () => {
    setSendForApprovalModalVisible(true);
  };

  const handleOkApprovalModal = () => {
    setSendForApprovalModalVisible(false);
  };

  const handleCancelApprovalModal = () => {
    setSendForApprovalModalVisible(false);
  };

  const indexCollection = () => {
    const userData = localStorage.getItem("user");
    const user = userData && JSON.parse(userData);
    setContinueButtonLoading(true);
    API_KEY.URL.get(
      `${process.env.REACT_APP_API_SERVICE}indexingService/collection_products`,
      {
        params: {
          collection_id: collectionDetails?.id,
          token: user?.access_token,
        },
      }
    ).then((res) => {
      console.log("res",res)
    }).catch((err) => {
      console.log(err);
    })
    //.then(res =>setContinueButtonLoading(false)).catch(err => setContinueButtonLoading(false))
  };
  const showGenarateCatalogoueModal = () => {
    indexCollection();
    validator();

    // if (!genarateCatalogoueModalVisible) {
    //   indexCollection();
    //   // setGenarateCatalogoueModalVisible(true);
    // }
  };

  const handleOkGenarateCatalogoueModal = () => {
    setGenarateCatalogoueModalVisible(false);
  };

  const handleCancelGenarateCatalogoueModal = () => {
    setGenarateCatalogoueModalVisible(false);
  };

  useEffect(() => {
    if (saving) {
      setShowCloudIcon(true);
    }
  }, [saving]);

  const menu = (
    <Menu style={{ width: 400 }}>
      <Menu.Item
        key="0"
        onClick={() => {
          showApprovalModal();
          gaEvent(
            GA.EVENT.CLICK,
            GA.CATEGORY.CREATE_COLLECTION,
            GA.DESCRIPTION.VIEW_COLLECTION_SEND_FOR_APPROVAL,
            collectionId
          );
        }}
        style={{ padding: "20px" }}
      >
        <Row justify="space-between" align="middle">
          <Col>
            <Row>
              <Title level={5}>Send for Approval</Title>
            </Row>
            <Row>
              <Text type="secondary">Get this catalogue approved by admin</Text>
            </Row>
          </Col>
          <Col>
            <img
              src={SendApproval}
              alt="Approve"
              height={"60px"}
              width={"60px"}
            />
          </Col>
        </Row>
      </Menu.Item>
      <Can I={PERMISSIONS.download_ppt_excel.slug} a={PERMISSIONS.download_ppt_excel.permissionType} >
      <Menu.Divider />
      <Menu.Item
        key="1"
        onClick={() => {
          showGenarateCatalogoueModal();
          gaEvent(
            GA.EVENT.CLICK,
            GA.CATEGORY.CREATE_COLLECTION,
            GA.DESCRIPTION.VIEW_COLLECTION_GENERATE_CATALOGUE,
            collectionId
          );
        }}
        style={{ padding: "20px" }}
      >
         <Row justify="space-between" align="middle">
          <Col>
            <Row>
              <Title level={5}>Generate Catalogue</Title>
            </Row>
            <Row>
              <Text type="secondary">Create catalogue for a buyer</Text>
            </Row>
          </Col>
          <Col>
            <img
              src={ShareCatalogue}
              alt="catlougue"
              height={"60px"}
              width={"60px"}
            />
          </Col>
        </Row>
     
      </Menu.Item>
      </Can>
    </Menu>
  );
  //Event handlers for scroll-lock
  const disableBody = (target) => disableBodyScroll(target);
  const enableBody = (target) => enableBodyScroll(target);

  const tourConfig = [
    {
      //Step - 1
      selector: '[data-tour="step-1"]',
      content: () => (
        <div>
          <span
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
            }}
          >
            <span className="arrow"></span>
          </span>
          <p>
            <Title
              level={5}
              style={{
                color: Colors.white,
                fontSize: 18,
                fontWeight: "bolder",
              }}
            >
              <b>You can update the selection of fields anytime!</b>
            </Title>
          </p>

          <p>
            <Text style={{ color: "#E6E7E7", fontSize: 14 }}>
              Cutomize the data that the buyer gets to see on this catalogue you
              share from here
            </Text>
          </p>
          <Button
            size="large"
            type="primary"
            onClick={() => {
              localStorage.setItem("new", false);
              enableBody(options);
              setShowTour(false);
            }}
            style={{ width: "100%" }}
          >
            Got it
          </Button>
        </div>
      ),
      style: {
        backgroundColor: "#1D2624",
        padding: "1.5em",
        width: "20em",
        top: -10,

        // overflow:'hidden',
      },
      position: "bottom",
    },
  ];
  const options = {
    reserveScrollBarGap: true,
  };

  return (
    <>
      <Tour
        onRequestClose={() => {
          setShowTour(false);
        }}
        steps={tourConfig}
        isOpen={showTour}
        rounded={5}
        closeButtonAriaLabel="Close"
        closeWithMask={false}
        disableDotsNavigation={false}
        // lastStepNextButton={
        //   <Button type="primary" onClick={()=>{localStorage.setItem("new",false);

        //   setShowTour(false)}} style={{width:'100%',marginTop:'1em'}}>Got it</Button>
        // }
        // maskClassName="remove"
        maskSpace={10}
        // nextButton={
        //   <Button type="primary" onClick={()=>{localStorage.setItem("new",false);

        //   setShowTour(false)}} style={{width:'100%',marginTop:'1em'}}>Got it</Button>
        // }
        position="top"
        showButtons={false}
        showCloseButton={false}
        showNavigation={false}
        showNumber={false}
        className="tourCard"
        // onAfterOpen={disableBody()}
        // onBeforeClose={enableBody()}
        disableInteraction={true}
        maskClassName="mask"
      />

      <SendForApprovalModal
        sendForApprovalModalVisible={sendForApprovalModalVisible}
        collectionDetails={collectionDetails}
        handleOkApprovalModal={handleOkApprovalModal}
        handleCancelApprovalModal={handleCancelApprovalModal}
        saveAsDraft={saveAsDraft}
      />

      <GenarateCatalogoueModal
        collectionDetails={collectionDetails}
        showGenarateCatalogoueModal={showGenarateCatalogoueModal}
        handleOkGenarateCatalogoueModal={handleOkGenarateCatalogoueModal}
        handleCancelGenarateCatalogoueModal={
          handleCancelGenarateCatalogoueModal
        }
        genarateCatalogoueModalVisible={genarateCatalogoueModalVisible}
        saveAsDraft={saveAsDraft}
        handleContinue={handleContinue}
        handlePreview={handlePreview}
        uniqueAttrs={uniqueAttrs}
      />
      <Row justify="space-between" align="middle" style={{ marginTop: "1em" }}>
        <Col span={6}>
          <Row align="middle">
            <Col>
              <Title style={{ fontSize: "23px", fontFamily: "Gilroy" }}>
                {collectionDetails ? (
                  collectionDetails?.collection_name
                ) : (
                  <Skeleton.Input style={{ width: 200 }} active />
                )}
              </Title>
            </Col>
            <Col>
              <Text type="secondary" style={{ fontSize: 12, marginLeft: 8 }}>
                {" "}
                {saving ? (
                  "Saving..."
                ) : showCloudIcon ? (
                  <IoCloudDoneOutline size={20} />
                ) : (
                  "Saved"
                )}
              </Text>
            </Col>
          </Row>
        </Col>

        <Col span={18}>
          <Row justify="space-between" align="middle">
            <Col span={5}>
              {collectionDetails ? (
                <span
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "0.5rem",
                  }}
                >
                  <Text style={{ fontSize: "15px" }}>Show Product Cost: </Text>
                  <Switch
                    checkedChildren={<b style={{ fontSize: 10 }}>Hide</b>}
                    unCheckedChildren={<b style={{ fontSize: 10 }}>Show</b>}
                    onChange={() => {
                      setShowInternals((state) => !state);
                      gaEvent(
                        GA.EVENT.CLICK,
                        GA.CATEGORY.CREATE_COLLECTION,
                        GA.DESCRIPTION.VIEW_COLLECTION_TOGGLE_PRODUCT_COST,
                        collectionId
                      );
                    }}
                  />
                </span>
              ) : (
                <Skeleton.Input style={{ width: 150 }} active />
              )}
            </Col>
            <Col span={6}>
              {collectionDetails ? (
                <Button
                  style={{
                    width: "100%",
                    height: 48,
                  }}
                  size="large"
                  onClick={() => {
                    history.push({
                      pathname: `/select-products/${collectionId}`,
                      state: {
                        type: "edit",
                      },
                    });
                    gaEvent(
                      GA.EVENT.CLICK,
                      GA.CATEGORY.CREATE_COLLECTION,
                      GA.DESCRIPTION.VIEW_COLLECTION_ADD_MORE_PRODUCTS_BUTTON,
                      collectionId
                    );
                  }}
                >
                  Add more products
                </Button>
              ) : (
                <Skeleton.Input style={{ width: 150 }} active />
              )}
            </Col>
            <Col span={6}>
              {collectionDetails ? (
                <Button
                  data-tour="step-1"
                  size="large"
                  disabled={tableData?.length === 0 ? true : false}
                  onClick={() => {
                    setFieldsModalVisible(true);
                    gaEvent(
                      GA.EVENT.CLICK,
                      GA.CATEGORY.CREATE_COLLECTION,
                      GA.DESCRIPTION.VIEW_COLLECTION_CUSTOMER_BUYER_VIEW_BUTTON,
                      collectionId
                    );
                  }}
                  icon={
                    <AiTwotoneShop
                      style={{
                        margin: -2,
                        marginRight: 5,
                        color: tableData?.length === 0 ? "gray" : "#0B7764",
                      }}
                    />
                  }
                  style={{
                    background: "#F0F8F6",
                    border: "1px solid #C9E4DF",
                    height: 48,
                    width: "100%",
                  }}
                >
                  Customize Buyer View
                </Button>
              ) : (
                <Skeleton.Input style={{ width: 150 }} active />
              )}
            </Col>
            <Col span={6}>
              {collectionDetails ? (
                <Dropdown
                  overlay={menu}
                  disabled={tableData?.length === 0 ? true : false}
                >
                  <Button
                    loading={continueButtonLoading}
                    disabled={tableData?.length === 0 ? true : false}
                    className="ant-dropdown-link"
                    style={{
                      width: "100%",
                      background: tableData?.length === 0 ? "gray" : "#040E0C",
                      border: 0,
                      height: 48,
                    }}
                    size="large"
                    type="primary"
                    onClick={() => {
                      gaEvent(
                        GA.EVENT.CLICK,
                        GA.CATEGORY.CREATE_COLLECTION,
                        GA.DESCRIPTION.VIEW_COLLECTION_CONTINUE_BUTTON,
                        collectionId
                      );
                    }}
                  >
                    Continue
                  </Button>
                </Dropdown>
              ) : (
                <Skeleton.Input style={{ width: 150 }} active />
              )}
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
}
